import { CompanyRoster } from 'api/worker'
import { toast, Loading } from 'ui'
import { RosterSelector } from 'components/RosterSelector'
import {
  useAddWorkerToRostersMutation,
  useInvalidateCompanyRosters,
} from 'queries/company'

interface Props {
  worker: {
    id: number
    name?: string
    rosters: {
      id: number
    }[]
  }
  onUpdated?: (rosters: Array<Pick<CompanyRoster, 'id' | 'name'>>) => void
  isOpen: boolean
  onClose: () => void
}

export function AddWorkerToListModal(props: Props) {
  const { onUpdated, worker, isOpen, onClose } = props
  const rosters = worker.rosters ?? []
  const rosterIds = rosters.map((item) => Number(item.id))

  const { invalidate: invalidateLists } = useInvalidateCompanyRosters()
  const { mutate: addToRosters, isPending: isAddingToRosters } =
    useAddWorkerToRostersMutation({
      workerId: Number(worker.id),
      onSuccess: (rosters) => {
        if (onUpdated) {
          onUpdated(rosters)
        }
        invalidateLists()
      },
      onError: (err) => {
        toast.error(err.message)
      },
    })

  const onRostersSelected = async (rosterIds: number[]) => {
    addToRosters(rosterIds)
    onClose()
  }

  if (isAddingToRosters) {
    return <Loading type={'button'} />
  }

  return (
    <RosterSelector
      key={isOpen ? 'open' : 'closed'} // Reset selection
      open={isOpen}
      title={`Add ${worker.name || 'Worker'} to Lists`}
      ctaText={'Add to Selected Lists'}
      showStats={false}
      onClose={onClose}
      selected={rosterIds}
      onChange={onRostersSelected}
    />
  )
}
